import { Controller } from '@hotwired/stimulus'
import { Interpolation, LineChart } from 'chartist'
import { format } from 'date-fns'
import { toStonesAndPounds } from '../../utils/weight-utils'

export default class extends Controller {
  static targets = ['chart']
  static values = {
    data: Object,
  }

  connect() {
    if (!this.hasChartTarget) return

    const labels = Object.keys(this.dataValue)
    const values = Object.values(this.dataValue).map(s =>
      s ? parseFloat(s) : null
    )

    const filtered = values.filter(v => v !== null)

    new LineChart(
      this.chartTarget,
      {
        labels,
        series: [
          {
            className: 'stroke-primary-500 fill-primary-500',
            data: values,
          },
        ],
      },
      {
        axisX: {
          labelInterpolationFnc: value => format(new Date(value), 'd MMM yy'),
        },
        axisY: {
          // type: FixedScaleAxis,
          labelInterpolationFnc: value => toStonesAndPounds(value),
          // showLabel: false,
          offset: 80,
          ticks: filtered,
          // low: Math.min(...filtered),
          // high: Math.max(...filtered),
        },
        lineSmooth: Interpolation.monotoneCubic({
          fillHoles: true,
        }),
        showArea: true,
        showPoint: true,
        fullWidth: true,
        showGridBackground: false,
        chartPadding: {
          right: 40,
        },
        reverseData: true,
      },
      [
        [
          'screen and (max-width: 640px)',
          {
            axisX: {
              labelInterpolationFnc: value => format(new Date(value), 'd/MM'),
            },
            axisY: {
              showLabel: false,
              offset: 0,
            },
          },
        ],
      ]
    )
  }
}
